<template>
  <div class="job">
    <div v-if="loading" class="loading-job">
      <fai class="icon" icon="spinner" spin />
    </div>
    <div v-else>
      <h1>Vous consultez l'offre "{{job.title}}"</h1>
      <div class="job-card">
        <h2>Offre d'emploi</h2>
        <section>
          <div class="section-header">Poste : {{job.title}}</div>
          <div class="section-body">
            <vue-markdown class="markdown">{{job.header}}</vue-markdown>
          </div>
        </section>
        <section>
          <div class="section-header">Présentation de l'offre</div>
          <div class="section-body">
            <vue-markdown class="markdown">{{job.body}}</vue-markdown>
          </div>
        </section>
        <section>
          <div class="section-header">Missions</div>
          <div class="section-body">
            <vue-markdown class="markdown">{{job.missions}}</vue-markdown>
          </div>
        </section>
        <section>
          <div class="section-header">Profil</div>
          <div class="section-body">
            <vue-markdown class="markdown">{{job.profil}}</vue-markdown>
          </div>
        </section>
        <ul class="informations">
          <li v-if="job.place">
            <fai class="icon" icon="map-marker"></fai>
            <div>{{job.place}}</div>
          </li>
          <li v-if="job.startAt">
            <fai class="icon" icon="calendar"></fai>
            <div>{{job.startAt}}</div>
          </li>
          <li>
            <fai class="icon" icon="file-invoice"></fai>
            <div>{{job.contract}} - {{job.duration}}</div>
          </li>
          <li v-if="job.availability">
            <fai class="icon" icon="clock"></fai>
            <div>{{job.availability}}</div>
          </li>
          <li v-if="job.salary">
            <fai class="icon" icon="credit-card"></fai>
            <div>{{job.salary}}</div>
          </li>
        </ul>
      </div>
      <div class="center my-5">
        <button class="job-button" @click="visibility = true">POSTULER</button>
      </div>
      <div class="job-form" v-if="visibility && !success">
        <h2 class="center mb-4">Remplissez le formulaire pour postuler</h2>
        <form @submit.prevent="apply()">
          <div class="form-input">
            <label for="lastname">CV *</label>
            <input required type="file" name="resume" @change="updateResume" accept="application/msword, application/pdf" />
          </div>
          <div class="form-input">
            <label for="lastname">Nom *</label>
            <input v-model="form.name" required type="text" name="lastname" placeholder="Indiquez votre nom" />
          </div>
          <div class="form-input">
            <label for="firstname">Prénom *</label>
            <input v-model="form.firstname" required type="text" name="firstname" placeholder="Indiquez votre prénom" />
          </div>
          <div class="form-input">
            <label for="email">Adresse email *</label>
            <input v-model="form.mail" type="email" name="email" placeholder="Indiquez votre adresse email" />
          </div>
          <div class="form-input">
            <label for="phone">Numéro de téléphone *</label>
            <input v-model="form.phone" required type="text" name="phone" placeholder="Indiquez votre numéro de téléphone" />
          </div>
          <!--<div class="form-input">
            <label for="phone">Comment avez-vous pris connaissance de l'offre ? *</label>
            <select name>
              <option value>zadaz</option>
            </select>
          </div>-->
          <div class="form-input">
            <label for="message">Quelque chose à rajouter ?</label>
            <textarea name="message" v-model="form.body" placeholder="Champ non obligatoire"></textarea>
          </div>
          <div class="center error" v-if="error">Une erreur est survenue, merci de vérifier les champs du formulaire.</div>
          <div class="center my-7">
            <button class="job-button" :type="applyLoading ? 'button' : 'submit'">
              <div class="loading-icon" v-if="applyLoading">
                <fai class="icon" icon="spinner" spin />
              </div>Envoyer
            </button>
          </div>
        </form>
        <div class="rgpd">
          Les données communiqués via ce formulaire font l’objet d’un traitement automatisé par Adventure Group, en sa qualité de responsable de traitement, dans le but de traiter et gérer votre candidature. Ce traitement de données est nécessaire à l’exécution de votre candidature.
          La personne en charge de la protection des données peut être contactée à l’adresse email suivante rh@adventuregroup.fr.
          Les données seront conservées 3 ans après le dernier contact avec le candidat si le poste ne lui est pas attribué. En cas d’embauche, les données pourront être conservées par l’employeur pendant toute la durée du contrat de travail.
          Dans le cadre de ses opérations de traitement, le responsable de traitement s’engage à ne pas transférer vos données personnelles en dehors de l’Union européenne.
          Vous disposez d’un droit d’accès, de rectification, et en cas de motifs légitimes de suppression, de limitation et d’opposition au traitement de vos données. Vous bénéficiez également du droit à la portabilité de vos données et de la possibilité de donner des directives concernant vos données, en cas de décès. Vous pouvez exercer ces droits en adressant un email à l’adresse rh@adventuregroup.fr.
        </div>
      </div>
      <div v-if="success" class="success">Merci pour ta candidature, on revient vers toi rapidement !</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      success: false,
      error: false,
      job: null,
      loading: false,
      visibility: false,
      applyLoading: false,
      form: {
        firstname: null,
        name: null,
        mail: null,
        body: null,
        phone: null,
      },
      resume: null,
    };
  },
  created() {
    this.fetchJob(this.$route.params.jobId);
  },
  methods: {
    async fetchJob(id) {
      try {
        this.loading = true;
        const res = await axios.get("https://etalent.herokuapp.com/job/" + id);
        this.job = res.data;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    updateResume(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.resume = files[0];
    },
    async apply() {
      try {
        this.applyLoading = true;
        this.error = false;
        this.success = false;
        var formData = new FormData();
        formData.append("resume", this.resume);
        formData.append("motivation", this.resume);
        formData.append("name", this.form.name);
        formData.append("firstname", this.form.firstname);
        formData.append("phone", this.form.phone);
        formData.append("mail", this.form.mail);
        formData.append("body", this.form.body);
        await axios.post(
          "https://etalent.herokuapp.com/apply/" + this.$route.params.jobId,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.applyLoading = false;
        this.success = true;
        this.error = false;
      } catch (err) {
        this.applyLoading = false;
        this.error = true;
        this.success = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.job {
  margin: 50px auto;
  width: $content-width;
  max-width: $max-width;
  .job-card {
    overflow: hidden;
    border-radius: 5px;
    display: block;
    border: 2px solid #dddddd;
    margin: 50px 0;
    padding: 40px 30px;
    h2 {
      text-align: center;
      margin: 15px 0;
    }
    section {
      .section-header {
        background: linear-gradient(90deg, $primary-D2 0%, $primary-D 100%);
        padding: 18px 15px;
        text-align: center;
        border-radius: 4px;
        color: #fff;
        font-weight: bold;
        font-size: 21px;
        margin: 25px 0;
      }
      .section-body {
        .markdown {
          line-height: 1.3;
          p,
          span,
          strong {
            padding-bottom: 10px;
            line-height: 2;
          }
        }
      }
    }
    .informations {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      margin-top: 30px;
      li {
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: flex-start;
        text-align: center;
        .icon {
          color: $primary-D2;
          font-size: 40px;
          margin-bottom: 20px;
        }
        div {
          font-size: 18px;
          font-weight: bold;
          color: $black;
        }
      }
    }
  }

  .job-form {
    overflow: hidden;
    border-radius: 5px;
    display: block;
    border: 2px solid #dddddd;
    margin: 50px 0;
    padding: 40px 30px;
    form {
      .form-input {
        label {
          display: block;
          font-weight: bold;
          font-size: 19px;
          margin-top: 18px;
          margin-bottom: 8px;
        }
        input,
        textarea,
        select {
          background: #fff;
          border: 1px solid #edefed;
          border-color: #dbdbdb;
          border-radius: 2px;
          width: 100%;
          box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
          padding: 10px 15px;
          font-size: 19px;
          &:focus,
          &:active {
            border-color: $primary-D;
            outline-color: $primary-D;
          }
        }
        textarea {
          height: 120px;
        }
      }
    }
    .rgpd {
      margin: 20px 0;
      text-align: left;
      line-height: 1.1;
    }
  }
  .job-button {
    background-color: $primary;
    color: #fff;
    padding: 13px 30px;
    border-radius: 20px;
    font-size: 25px;
    transition: background-color 0.4s;
    margin: 10px 0;
    display: inline-block;
    font-weight: bold;
    position: relative;
    overflow: hidden;
    &:hover {
      background-color: $primary-D;
    }
    .loading-icon {
      position: absolute;
      background: $primary;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .error {
    color: #d84551;
    margin-top: 30px;
    font-size: 25px;
    font-weight: bold;
  }
  .success {
    color: #27ae60;
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    margin: 20px 0;
  }
}
.loading-job {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 200px auto;
  .icon {
    font-size: 56px;
    color: $primary;
  }
}
</style>
